module.exports = "<svg fill=\"#379FD1\" viewBox=\"0 0 28 28\"><path d=\"M6.68 25.862a2.125 2.125 0 0 1-1.556-.652 2.125 2.125 0 0 1-.653-1.557V4.348c0-.604.218-1.124.653-1.56a2.123 2.123 0 0 1 1.557-.654h9.223c.302 0 .589.059.862.177.273.119.51.279.712.48l5.398 5.398c.201.201.361.439.48.712.118.273.177.56.177.862v13.89c0 .603-.218 1.121-.654 1.557a2.132 2.132 0 0 1-1.56.652H6.681zM15.7 8.804V4.348H6.68v19.305h14.64V9.909h-4.515c-.31 0-.573-.106-.785-.319a1.068 1.068 0 0 1-.32-.786z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/file.svg
// module id = 299
// module chunks = 1